module.exports = __webpack_public_path__ + "img/drop-right-gray.18c6864f.svg";